if (!customElements.get('newsletter-modal')) {
  customElements.define(
    'newsletter-modal',
    class NewsletterModal extends ModalElement {
      constructor() {
        super();
    
        // Prevent popup on Shopify robot challenge page
        if (window.location.pathname === '/challenge' || !theme.cookiesEnabled) {
          return;
        }
    
        if (!theme.config.isTouch || Shopify.designMode) {
          this.init();
        }
        else {
          new theme.initWhenVisible(theme.utils.throttle(this.init.bind(this)));
        }
      }
    
      get shouldLock() {
        return true;
      }
    
      get testMode() {
        return this.getAttribute('data-test-mode') === 'true';
      }
    
      get delay() {
        return this.hasAttribute('data-delay') ? parseInt(this.getAttribute('data-delay')) : 5;
      }
    
      get expiry() {
        return this.hasAttribute('data-expiry') ? parseInt(this.getAttribute('data-expiry')) : 30;
      }
    
      get cookieName() {
        return 'concept:dida-routine-finder:v1';
      }
    
      get submited() {
        return this.querySelector('.alert') !== null;
      }
    
      init() {
        if (this.initialized) return;
        this.initialized = true;
        
        // Open modal if errors or success message exist
        if (this.submited) {
          this.load(1);
          return;
        }
    
        if (this.testMode || !this.getCookie(this.cookieName)) {
          this.load(this.delay);
        }
      }
    
      load(delay) {
        if (Shopify.designMode) return;
    
        setTimeout(() => this.show(), delay * 1000);
      }
    
      afterShow() {
        super.afterShow();
        this.classList.add('show-image');
      }
    
      afterHide() {
        super.afterHide();
        this.classList.remove('show-image');
    
        // Remove a cookie in case it was set in test mode
        if (this.testMode) {
          this.removeCookie(this.cookieName);
          return;
        }
    
        this.setCookie(this.cookieName, this.expiry);
      }
    
      getCookie(name) {
        const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
        return match ? match[2] : null;
      }
    
      setCookie(name, expiry) {
        document.cookie = `${name}=true; max-age=${(expiry * 24 * 60 * 60)}; path=/`;
      }
    
      removeCookie(name) {
        document.cookie = `${name}=; max-age=0`;
      }
    }
  );
}


const initDidaRoutineFinders = (root = document) => {
  root.querySelectorAll('form.dida-routine-finder:not([data-routine-initialized])').forEach((form) => {
    form.setAttribute('data-routine-initialized', 'true');

    const tagsInput = form.querySelector('[data-routine-tags]');
    const noteInput = form.querySelector('[data-routine-note]');
    const result = form.querySelector('[data-routine-result]');
    const resultTitle = form.querySelector('[data-routine-result-title]');
    const resultCopy = form.querySelector('[data-routine-result-copy]');
    const phoneInput = form.querySelector('[data-routine-phone]');
    const smsConsent = form.querySelector('[data-routine-sms-consent]');
    const submitText = form.querySelector('[data-routine-submit-text]');
    const state = {
      interest: '',
      answer: '',
      pain: '',
      title: '',
      copy: ''
    };

    const sanitizeTagValue = (value) => value.toString().trim().toLowerCase().replace(/[^a-z0-9-]+/g, '-').replace(/^-+|-+$/g, '');

    const updateTags = () => {
      const baseTags = tagsInput?.dataset.baseTags || 'newsletter,client:dida,source:popup_routine_finder';
      const tags = [baseTags];
      if (state.interest) tags.push(`interest:${sanitizeTagValue(state.interest)}`);
      if (state.answer) tags.push(`finish:${sanitizeTagValue(state.answer)}`);
      if (state.pain) tags.push(`pain:${sanitizeTagValue(state.pain)}`);

      const hasPhone = phoneInput && phoneInput.value.trim().length > 0;
      const hasSmsConsent = smsConsent && smsConsent.checked;
      if (hasPhone && hasSmsConsent) {
        tags.push('offer:dida15', 'sms_requested:true');
        if (submitText) submitText.textContent = 'Save my routine + 15% off';
      }
      else {
        tags.push('offer:dida10');
        if (submitText) submitText.textContent = 'Save my routine + 10% off';
      }

      if (tagsInput) tagsInput.value = tags.join(',');
      if (noteInput) {
        const note = [`Routine finder source: popup_routine_finder`];
        if (state.title) note.push(`Recommendation: ${state.title}`);
        if (state.answer) note.push(`Finish: ${state.answer}`);
        if (state.pain) note.push(`Pain point: ${state.pain}`);
        if (hasPhone && hasSmsConsent) note.push('SMS consent checkbox accepted in storefront form');
        noteInput.value = note.join(' | ');
      }
    };

    form.querySelectorAll('[data-routine-interest]').forEach((button) => {
      button.addEventListener('click', () => {
        form.querySelectorAll('[data-routine-interest]').forEach((option) => option.classList.remove('is-selected'));
        button.classList.add('is-selected');
        state.interest = button.dataset.routineInterest || '';
        state.answer = button.dataset.routineAnswer || '';
        state.title = button.dataset.routineTitle || '';
        state.copy = button.dataset.routineCopy || '';
        if (result && resultTitle && resultCopy) {
          result.hidden = false;
          resultTitle.textContent = state.title;
          resultCopy.textContent = state.copy;
        }
        updateTags();
      });
    });

    form.querySelectorAll('[data-routine-pain]').forEach((button) => {
      button.addEventListener('click', () => {
        form.querySelectorAll('[data-routine-pain]').forEach((option) => option.classList.remove('is-selected'));
        button.classList.add('is-selected');
        state.pain = button.dataset.routinePain || '';
        updateTags();
      });
    });

    [phoneInput, smsConsent].forEach((field) => {
      if (!field) return;
      field.addEventListener('input', updateTags);
      field.addEventListener('change', updateTags);
    });

    form.addEventListener('submit', (event) => {
      const hasPhone = phoneInput && phoneInput.value.trim().length > 0;
      const hasSmsConsent = smsConsent && smsConsent.checked;
      if (hasPhone && !hasSmsConsent) {
        event.preventDefault();
        smsConsent.setCustomValidity('Check the SMS consent box to unlock the 15% text offer, or remove your phone number to continue with 10% off.');
        smsConsent.reportValidity();
        return;
      }
      if (!hasPhone && hasSmsConsent) {
        event.preventDefault();
        phoneInput.setCustomValidity('Enter your mobile number to unlock the 15% text offer.');
        phoneInput.reportValidity();
        return;
      }
      if (smsConsent) smsConsent.setCustomValidity('');
      if (phoneInput) phoneInput.setCustomValidity('');
      updateTags();
    });

    updateTags();
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initDidaRoutineFinders());
}
else {
  initDidaRoutineFinders();
}

document.addEventListener('shopify:section:load', (event) => initDidaRoutineFinders(event.target));
